import PropTypes from 'prop-types';

// material-ui
import Button from '@mui/material/Button';

// assets
import GlobalOutlined from '@ant-design/icons/GlobalOutlined';

// project imports
import { LANGUAGES, lang, setLang } from 'i18n';

// ==============================|| LANGUAGE SWITCHER ||============================== //

// One button showing the *other* language's name — clicking it switches (and reloads, see i18n).
export default function LanguageSwitcher({ sx }) {
  const other = LANGUAGES.find((l) => l.code !== lang);

  return (
    <Button
      color="secondary"
      variant="outlined"
      size="small"
      startIcon={<GlobalOutlined />}
      onClick={() => setLang(other.code)}
      sx={{ flexShrink: 0, whiteSpace: 'nowrap', ...sx }}
      lang={other.code}
    >
      {other.label}
    </Button>
  );
}

LanguageSwitcher.propTypes = { sx: PropTypes.object };
